export const checkCapsLock = (
    e: React.KeyboardEvent, 
    callback: (isCapsLock: boolean) => void
): void => {
    const isCapsLock = e.getModifierState?.('CapsLock') || false;
    callback(isCapsLock);
};
